import React, { Component } from 'react';
import { func, object } from 'prop-types';
import { connect } from 'react-redux';

import { activateFilterPanel } from 'PipeRouter';
import FilterPanelViews from './views';


class FilterPanel extends Component {
  constructor(props) {
    super(props);
  }

  handleClick = () => {
    this.props.activateFilterPanel();
  }

  render() {
    const { notebook:{ isFilterPanelOpen }} = this.props;

    const viewProps = {
      handleClick: this.handleClick,
      isFilterPanelOpen
    };

    return <FilterPanelViews { ...viewProps } />;
  }
}

FilterPanel.propTypes = {
  activateFilterPanel: func,
  notebook: object
};


function mapStateToProps(state) {
  const { notebook } = state;

  return {
    notebook
  };
}


export default connect(mapStateToProps, {
  activateFilterPanel
})(FilterPanel);
